import React, { ReactElement } from "react";
import Position from "../../../enums/Position";
import WDPositionContainer from "../WDPositionContainer";
import WDHomeIcon from "../icons/WDHomeIcon";

const TopRight = function (): ReactElement {
  return (
    <WDPositionContainer position={Position.TOP_RIGHT} zIndex={50}>
      {/*
        回主界面直接落到「我的对局」而不是大厅默认页签：进对局的目的
        就是看自己这局，回大厅再点一次 tab 纯属多余。

        zIndex 要高于观战横幅（40）：观战时横幅是整条压在顶部的，
        把图标盖住就等于没有回大厅的入口了。
      */}
      <a href="/gamelistings.php?gamelistType=My%20games">
        <WDHomeIcon />
      </a>
    </WDPositionContainer>
  );
};

export default TopRight;
